import { registerPlugin } from '@capacitor/core';
import { type ShopflowDeviceInfo as Type } from './definitions';

export const ShopflowDeviceInfo = registerPlugin<Type>('ShopflowDeviceInfo', {
  web: () => import('./web').then(m => new m.ShopflowDeviceInfoWeb()),
});
